import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const getPartPriceFactors = (partCode) => apiActionCreator({
  'endpoint': `/price-factors/${partCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PART_PRICE_FACTORS_REQUEST,
    ActionTypes.GET_PART_PRICE_FACTORS_SUCCESS,
    [
      ActionTypes.GET_PART_PRICE_FACTORS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getPartMasterInfo = (partCode) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/parts/master/${partCode}`,
      'authenticated': true,
      'types': [
        ActionTypes.GET_PART_MASTER_INFO_REQUEST,
        () => {
          dispatch(getPartPriceFactors(partCode));
          return {'type': ActionTypes.GET_PART_MASTER_INFO_SUCCESS};
        },
        [
          ActionTypes.GET_PART_MASTER_INFO_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const getPartRejectionInfo = (partCode) => apiActionCreator({
  'endpoint': `/parts/${partCode}/rejection`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PART_REJECTION_INFO_REQUEST,
    ActionTypes.GET_PART_REJECTION_INFO_SUCCESS,
    [
      ActionTypes.GET_PART_REJECTION_INFO_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const savePartMasterInfo = (data) => apiActionCreator({
  'endpoint': '/parts/master',
  'authenticated': true,
  'types': [
    ActionTypes.SAVE_PART_MASTER_INFO_REQUEST,
    [
      ActionTypes.SAVE_PART_MASTER_INFO_SUCCESS,
      MessageActions.addMessageBoxInfo('Repuesto guardado satisfactoriamente'),
    ],
    [
      ActionTypes.SAVE_PART_MASTER_INFO_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const editPartMasterInfo = (partCode, data) => apiActionCreator({
  'endpoint': `/parts/master/${partCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.EDIT_PART_MASTER_INFO_REQUEST,
    [
      ActionTypes.EDIT_PART_MASTER_INFO_SUCCESS,
      MessageActions.addMessageBoxInfo('Repuesto guardado satisfactoriamente'),
    ],
    [
      ActionTypes.EDIT_PART_MASTER_INFO_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': data,
});

export const getPartEquivalences = (partCode) => apiActionCreator({
  'endpoint': `/parts/${partCode}/equivalences`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PART_EQUIVALENCES_REQUEST,
    ActionTypes.GET_PART_EQUIVALENCES_SUCCESS,
    [
      ActionTypes.GET_PART_EQUIVALENCES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getPartSubstitutes = (partCode) => apiActionCreator({
  'endpoint': `/parts/${partCode}/substitutes`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PART_SUBSTITUTES_REQUEST,
    ActionTypes.GET_PART_SUBSTITUTES_SUCCESS,
    [
      ActionTypes.GET_PART_SUBSTITUTES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getPartSpecialSubstitutes = (partCode) => apiActionCreator({
  'endpoint': `/parts/${partCode}/special-substitutes`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PART_SPECIAL_SUBSTITUTES_REQUEST,
    ActionTypes.GET_PART_SPECIAL_SUBSTITUTES_SUCCESS,
    [
      ActionTypes.GET_PART_SPECIAL_SUBSTITUTES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const savePartSubstitute = (partCode, data) => apiActionCreator({
  'endpoint': `/parts/${partCode}/substitutes`,
  'authenticated': true,
  'types': [
    ActionTypes.SAVE_PART_SUBSTITUTES_REQUEST,
    ActionTypes.SAVE_PART_SUBSTITUTES_SUCCESS,
    [
      ActionTypes.SAVE_PART_SUBSTITUTES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const savePartSpecialSubstitute = (partCode, data) => apiActionCreator({
  'endpoint': `/parts/${partCode}/special-substitutes`,
  'authenticated': true,
  'types': [
    ActionTypes.SAVE_PART_SPECIAL_SUBSTITUTES_REQUEST,
    ActionTypes.SAVE_PART_SPECIAL_SUBSTITUTES_SUCCESS,
    [
      ActionTypes.SAVE_PART_SPECIAL_SUBSTITUTES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const savePartEquivalence = (partCode, data) => apiActionCreator({
  'endpoint': `/parts/${partCode}/equivalences`,
  'authenticated': true,
  'types': [
    ActionTypes.SAVE_PART_EQUIVALENCES_REQUEST,
    ActionTypes.SAVE_PART_EQUIVALENCES_SUCCESS,
    [
      ActionTypes.SAVE_PART_EQUIVALENCES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const deletePartSubstitute = (partCode, substituteCode) => apiActionCreator({
  'endpoint': `/parts/${partCode}/substitutes`,
  'authenticated': true,
  'types': [
    ActionTypes.DELETE_PART_SUBSTITUTE_REQUEST,
    {
      'type': ActionTypes.DELETE_PART_SUBSTITUTE_SUCCESS,
      'payload': substituteCode,
    },
    [
      ActionTypes.DELETE_PART_SUBSTITUTE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'DELETE',
  'contentType': 'application/json',
  'data': {'code': substituteCode},
});

export const deletePartSpecialSubstitute = (partCode) => apiActionCreator({
  'endpoint': `/parts/${partCode}/special-substitutes`,
  'authenticated': true,
  'types': [
    ActionTypes.DELETE_PART_SPECIAL_SUBSTITUTE_REQUEST,
    ActionTypes.DELETE_PART_SPECIAL_SUBSTITUTE_SUCCESS,
    [
      ActionTypes.DELETE_PART_SPECIAL_SUBSTITUTE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'DELETE',
});

export const deletePartEquivalence = (partCode, equivalentCode) => apiActionCreator({
  'endpoint': `/parts/${partCode}/equivalences/${equivalentCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.DELETE_PART_EQUIVALENCE_REQUEST,
    {
      'type': ActionTypes.DELETE_PART_EQUIVALENCE_SUCCESS,
      'payload': equivalentCode,
    },
    [
      ActionTypes.DELETE_PART_EQUIVALENCE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'DELETE',
  'contentType': 'application/json',
});

export const getPartCarModels = (parameters = null) => apiActionCreator({
  'endpoint': `/parts/cars-models${getUrlParameters(parameters)}`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PART_CAR_MODEL_REQUEST,
    ActionTypes.GET_PART_CAR_MODEL_SUCCESS,
    [
      ActionTypes.GET_PART_CAR_MODEL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getPartGreyCarModels = () => apiActionCreator({
  'endpoint': '/parts/grey-cars-models',
  'authenticated': true,
  'types': [
    ActionTypes.GET_GREY_CAR_MODELS_REQUEST,
    ActionTypes.GET_GREY_CAR_MODELS_SUCCESS,
    [
      ActionTypes.GET_GREY_CAR_MODELS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getPartCarCompatibility = (partCode) => apiActionCreator({
  'endpoint': `/parts/${partCode}/compatibility`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PART_CAR_COMPATIBILITY_REQUEST,
    ActionTypes.GET_PART_CAR_COMPATIBILITY_SUCCESS,
    [
      ActionTypes.GET_PART_CAR_COMPATIBILITY_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const savePartCarCompatibility = (partCode, data) => apiActionCreator({
  'endpoint': `/parts/${partCode}/compatibility`,
  'authenticated': true,
  'types': [
    ActionTypes.SAVE_PART_CAR_COMPATIBILITY_REQUEST,
    {
      'type': ActionTypes.SAVE_PART_CAR_COMPATIBILITY_SUCCESS,
      'payload': data,
    },
    [
      ActionTypes.SAVE_PART_CAR_COMPATIBILITY_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const savePartImage = (partCode, data) => apiActionCreator({
  'endpoint': `/images/parts/${partCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.SAVE_PART_IMAGE_REQUEST,
    {
      'type': ActionTypes.SAVE_PART_IMAGE_SUCCESS,
      'payload': data,
    },
    [
      ActionTypes.SAVE_PART_IMAGE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'data': data,
});

export const getPartVerification = (partCode) => apiActionCreator({
  'endpoint': `/parts/${partCode}/verification`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PART_VERIFICATION_REQUEST,
    ActionTypes.GET_PART_VERIFICATION_SUCCESS,
    [
      ActionTypes.GET_PART_VERIFICATION_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getProductCodePriceFactors = (priceFactor) => apiActionCreator({
  'endpoint': `/price-factors/product-codes/${priceFactor}`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PRODUCT_CODE_PRICE_FACTORS_REQUEST,
    ActionTypes.GET_PRODUCT_CODE_PRICE_FACTORS_SUCCESS,
    [
      ActionTypes.GET_PRODUCT_CODE_PRICE_FACTORS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getFranchiseesList = () =>
  apiActionCreator({
    'endpoint': '/parts/franchise',
    'authenticated': true,
    'types': [
      ActionTypes.GET_FRANCHISEES_LIST_REQUEST,
      ActionTypes.GET_FRANCHISEES_LIST_SUCCESS,
      [
        ActionTypes.GET_FRANCHISEES_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const updatePartFranchise = (data) =>
  apiActionCreator({
    'endpoint': '/parts/franchise',
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_PART_FRANCHISE,
      [
        ActionTypes.UPDATED_PART_FRANCHISE_SUCCESS,
        (response) => MessageActions.addMessageBoxInfo(response.message),
      ],
      [
        ActionTypes.UPDATED_PART_FRANCHISE_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'contentType': 'application/json',
    'method': 'POST',
    'data': data,
  });

export const getpartSCCList = () =>
  apiActionCreator({
    'endpoint': '/parts/scc',
    'authenticated': true,
    'types': [
      ActionTypes.GET_PART_SCC_LIST_REQUEST,
      ActionTypes.GET_PART_SCC_LIST_SUCCESS,
      [
        ActionTypes.GET_PART_SCC_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const deletePartCarCompatibility = (partCode, lineNumber) => apiActionCreator({
  'endpoint': `/parts/${partCode}/compatibility/${lineNumber}`,
  'authenticated': true,
  'types': [
    ActionTypes.DELETE_PART_CAR_COMPATIBILITY_REQUEST,
    {
      'type': ActionTypes.DELETE_PART_CAR_COMPATIBILITY_SUCCESS,
      'payload': lineNumber,
    },
    [
      ActionTypes.DELETE_PART_CAR_COMPATIBILITY_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'DELETE',
});

export const changeUnregisteredSubstitute = (value) => ({
  'type': ActionTypes.CHANGE_UNREGISTERED_SUBSTITUTE_VALUE,
  'payload': value,
});

export const restorePartsFormValues = () => ({
  'type': ActionTypes.RESTORE_PARTS_MASTER_VALUES,
});

export const changePartsFormValue = (field, value) => ({
  'type': ActionTypes.CHANGE_PARTS_FORM_VALUE,
  'payload': {field, value},
});

export const togglePartFormConfirmation = (value = false, messages = []) => ({
  'type': ActionTypes.TOGGLE_PART_FORM_CONFIRMATION,
  'payload': {value, messages},
});

export const updatePartVerificationStatus = (value = false) => ({
  'type': ActionTypes.UPDATE_PART_VERIFICATION_STATUS,
  'payload': value,
});

export const clearReplacementSectionPartQuotes = () => ({
  'type': ActionTypes.CLEAR_REPLACEMENT_SECTION_PART_QUOTES,
});

export const fetchPartAttachments = (id) =>
  apiActionCreator({
    'endpoint': `/parts/${id}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_PART_ATTACHMENTS,
      ActionTypes.FETCHED_PART_ATTACHMENTS,
      [
        ActionTypes.FETCHED_PART_ATTACHMENTS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'form',
    'method': 'GET',
  });


export const savePartAttachments = (id, data) =>
  apiActionCreator({
    'endpoint': `/parts/${id}`,
    'authenticated': true,
    'types': [
      ActionTypes.SAVING_PART_ATTACHMENTS,
      [
        ActionTypes.SAVED_PART_ATTACHMENTS,
        MessageActions.addMessageBoxInfo(
          'Adjuntos guardados satisfactoriamente'
        ),
      ],
      [
        ActionTypes.SAVED_PART_ATTACHMENTS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'form',
    'method': 'POST',
    'isMultipart': true,
    data,
  });
  
export const updatePartHaveFiles = (partCode, haveFiles) =>
  apiActionCreator({
    'endpoint': `/parts/master/${partCode}`,
    'authenticated': true,
    'types': [
      ActionTypes.UPDATE_HAVE_FILES_REQUEST,
      ActionTypes.UPDATE_HAVE_FILES_SUCCESS,
      ActionTypes.UPDATE_HAVE_FILES_FAILED,
    ],
    'microservice': 'part',
    'method': 'PATCH',
    'contentType': 'application/json',
    'data': {'haveFiles': haveFiles},
  });
export const validatePartMaster = (partCode) =>
  apiActionCreator({
    'endpoint': `/parts/validate/${partCode}`,
    'authenticated': true,
    'types': [
      ActionTypes.VALIDATE_PART_REQUEST,
      ActionTypes.VALIDATE_PART_SUCCESS,
      ActionTypes.VALIDATE_PART_FAILED,
    ],
    'microservice': 'part',
    'method': 'GET',
  });
  

export const setPartAttachments = (files) => ({
  'type': ActionTypes.SET_PART_FILES,
  'payload': files,
});
